import type { SorterResult } from "antd/lib/table/interface";
import { type ExtendedColumnsType, GenericTable, type ResourceTableProps } from "components";
import { type FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { displayDateTimeValue } from "../../../../../components/Table/components/PropertyTable/transformations/cellTransformations";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../core/router/types/routerTypes";
import type { VirtualSiteGroupList } from "../../types/VirtualSiteGroupList";

export const VirtualSiteGroupsTable: FC<ResourceTableProps<VirtualSiteGroupList>> = ({
    onStateChanged,
    onRowSelectionChange,
    datasource,
    resource,
}) => {
    const { t } = useTranslation();
    const getColumnsConfig = useCallback(
        (sortInfo: SorterResult<VirtualSiteGroupList>): ExtendedColumnsType<VirtualSiteGroupList>[] => {
            return [
                {
                    title: t("list.form.id"),
                    dataIndex: "id",
                    key: "id",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "id" ? sortInfo.order : null,
                },
                {
                    title: t("virtualSiteGroupSearchForm.criteriaBadges.name"),
                    dataIndex: "name",
                    key: "name",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "name" ? sortInfo.order : null,
                },
                {
                    title: t("virtualSiteGroupSearchForm.criteriaBadges.priority"),
                    dataIndex: "priority",
                    key: "priority",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "priority" ? sortInfo.order : null,
                },
                {
                    title: t("genericTable.column.changed"),
                    dataIndex: "changed",
                    key: "changed",
                    render: (value) => displayDateTimeValue(value),
                },
            ];
        },
        [t],
    );

    const navigate = useNavigate();
    const onRowClick = (record: VirtualSiteGroupList) => {
        navigate(`${BASE_PATH}/${ResourceName.VIRTUAL_SITE_GROUPS}/${FORM_ACTION.EDIT}/${record.id}`);
    };

    return (
        (datasource && (
            <GenericTable<VirtualSiteGroupList>
                getColumnsConfig={getColumnsConfig}
                datasource={datasource}
                name="virtual_site_groups_table"
                onSelectionCallback={onRowSelectionChange}
                onStateChanged={onStateChanged}
                onRow={(record: VirtualSiteGroupList) => {
                    return {
                        onClick: () => onRowClick(record),
                    };
                }}
                resource={resource}
            />
        )) ||
        null
    );
};
